import { ERentTime, getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { RENT_TIME_MAP_VALUE_TO_LABEL } from './constants';

const ID = 'rentTime' as const;

export const rentTimeTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const rentTime = getTermValue('for_day')(jsonQuery);

    if (
      rentTime === null ||
      rentTime === ERentTime.NotDaily ||
      rentTime === ERentTime.Daily ||
      rentTime === ERentTime.AnyTerm
    ) {
      return null;
    }

    return [{ label: RENT_TIME_MAP_VALUE_TO_LABEL[rentTime], value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['for_day'])(jsonQuery),
};
